<script lang="ts">
    import Embed from '$lib/components/_DisplayComponents/Embed/Embed.svelte';
    import { getCookiePreferences } from '$lib/helper';
    import { mediaCookiesAccepted } from '$lib/Stores/stores';
    import ExternalContentOverlay from '../../ConsentOverlay/ExternalContent/ExternalContent.svelte';

    // Types
    import type { Language } from '$lib/types/Language';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let content = {};
    export let campaignId = '';
    export let cookiesEnabled = false;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let language: Language = 'de';

    const cookies = getCookiePreferences(campaignId);

    $: acceptedMediaOverlay = cookies.Media || $mediaCookiesAccepted;
</script>

{#if cookiesEnabled && !acceptedMediaOverlay && (content.head || content.body)}
    <ExternalContentOverlay
        {campaignId}
        {language}
        {transitionDelay}
        {transitionEffect}
        bgColor={content.box.backgroundColor}
    />
{:else}
    <svelte:component
        this={Embed}
        box={content.box}
        head={content.head}
        body={content.body}
        src={content.src}
        provider={content.provider}
        bgColor={content.box.backgroundColor}
        {transitionDelay}
        {transitionEffect}
    />
{/if}
